export default __webpack_public_path__ + "static/media/12-2.475652dd.mp3";